// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.img-wrap[data-v-b22e9df8]{\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n   margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
